import { Skeleton, Stack, Typography } from "@mui/material";
import { CardTransactionsSummaryLabel } from "Components/CardTransactions/CardTransactionsSummaryLabel";

type Props = {
  title: string;
  amount: string;
  countText: string;
  isLoading: boolean;
};

export const CardTransactionsSummaryTile = ({
  title,
  amount,
  countText,
  isLoading,
}: Props) => (
  <Stack gap={0.5}>
    <CardTransactionsSummaryLabel>{title}</CardTransactionsSummaryLabel>
    {isLoading ? (
      <Skeleton variant="text" width={160} height={32} />
    ) : (
      <>
        <Typography variant="h5" fontWeight={500}>
          {amount}
        </Typography>
        <Typography fontSize={14}>{countText}</Typography>
      </>
    )}
  </Stack>
);
